import React, { useEffect } from 'react';
import  classes from "./Teacher.module.css"
import BlueBtn from './../../Components/SidBarButtons/BlueBtn';
import { VscReferences } from "react-icons/vsc"
import classnames from 'classnames';
import { teacher } from './../../store/teacher';
import { teacherProperty } from './../../store/teacherProperty';
import { getTeacherPhoto } from '../../Service/properties';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import {appName} from '../../Service/http'



function TeacherPerson() {
    const { t, i18n } = useTranslation();
    const getPhoto = async(id: number) => {
        const result = await getTeacherPhoto(id) 
        if(result){
            teacherProperty.newPhoto(result)
        }else{
            teacherProperty.newPhoto("")
        }
    }

    useEffect(() => {
        if(teacher.teacher.id_teacher){
            getPhoto(teacher.teacher.id_teacher)
        }
    }, [teacher.teacher.id_teacher])

    return ( 
        <div className={classes.person}>
            <div className={classes.photo}>
                <img src={ teacherProperty.photo? "data:image/jpg;base64," + teacherProperty.photo : `${appName}/img/user.png`} className={classes.img} alt="" />
            </div>
            <div className={classes.content}>
                <div className={classes.content_top}>
                    <div className={classnames(classes.name, classes.align_left)}>
                        {
                            teacher.teacher.t_fio
                        }
                    </div>
                    <div className={classnames(classes.kafedra, classes.align_left)}>
                        {t("st:other.kafedra") } 
                    </div>
                    <div className={classnames(classes.post, classes.align_left)}>
                        {
                            teacher.teacher.post
                        }
                    </div>
                </div>
                <div className={classnames(classes.btn_wrap, classes.align_left)}>
                    {
                        !!teacher.teacher.id_teacher && <a target="_blank" href={ "/bt/api/teacher/t-r?id_teacher=" + teacher.teacher.id_teacher + `&lang=${i18n.language}` }>
                        <BlueBtn title={ t("st:other.demand") } onclick={() => {}}>
                            <VscReferences/>
                        </BlueBtn>
                    </a>
                    }
                </div>
            </div>
        </div>
     );
}

export default observer( TeacherPerson );